module.exports = __webpack_public_path__ + "img/logo_white.22228246.svg";